import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * 일일 보유 현황 수동 갱신 서비스
 */
class DataManagementService {
  /**
   * 일일 보유 현황 데이터를 수동으로 갱신
   * @param {string} date - 갱신할 날짜 (YYYY-MM-DD 형식, 선택사항)
   * @param {number} accountId - 특정 계좌 ID (선택사항)
   * @param {boolean} force - 기존 데이터 덮어쓰기 여부
   * @returns {Promise} API 응답
   */
  async refreshDailyHoldings(date = null, accountId = null, force = true) {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('인증 토큰이 없습니다. 다시 로그인해주세요.');
      }

      const requestData = {
        force: force
      };

      if (date) {
        requestData.date = date;
      }

      if (accountId) {
        requestData.account_id = accountId;
      }

      const response = await axios.post(
        `${API_URL}/api/data_predator/refresh-data/`,
        requestData,
        {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('일일 보유 현황 갱신 실패:', error);
      
      let errorMessage = '데이터 갱신에 실패했습니다.';
      
      if (error.response) {
        if (error.response.status === 401) {
          errorMessage = '인증이 만료되었습니다. 다시 로그인해주세요.';
        } else if (error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
      } else if (error.request) {
        errorMessage = '서버에 연결할 수 없습니다. 네트워크를 확인해주세요.';
      }

      return {
        success: false,
        error: errorMessage
      };
    }
  }

  /**
   * 현재 날짜로 일일 보유 현황 갱신 (기본 동작)
   */
  async refreshToday() {
    const today = new Date().toISOString().split('T')[0];
    return this.refreshDailyHoldings(today, null, true);
  }
}

export default new DataManagementService();
